import { render, staticRenderFns } from "./video5.vue?vue&type=template&id=1048e5ad&scoped=true&"
import script from "./video5.vue?vue&type=script&lang=js&"
export * from "./video5.vue?vue&type=script&lang=js&"
import style0 from "./video5.vue?vue&type=style&index=0&id=1048e5ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1048e5ad",
  null
  
)

export default component.exports